import { Trans } from '@mc/i18n'

import classes from './styles.module.scss'

interface DescriptionSectionProps {
  description: string
  starring: string
  length: number
  categories: string
}

interface InfoItemProps {
  i18nKey: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>
  className?: string
}

const InfoItem = ({ i18nKey, values, className }: InfoItemProps) => (
  <p className={`d-flex align-items-baseline ${className}`}>
    <Trans i18nKey={i18nKey} values={values} ns='@mc/next'>
      <span className='mc-text-small mc-opacity--muted' />
      <span className='mc-text-h7 mc-ml-1' />
    </Trans>
  </p>
)

export const DescriptionSection = ({
  description,
  starring,
  length,
  categories,
}: DescriptionSectionProps) => (
  <>
    <p className='mc-mt-4 mc-mb-2 mc-text--bold'>
      <Trans i18nKey='series.about.title' ns='@mc/next'>
        <span className='mc-text-h7' />
      </Trans>
    </p>
    <div className='mc-corners--sm mc-px-4 mc-py-5 mc-bg-neutral-900 flex-grow-1'>
      <div className={`${classes.scrollOuter} mc-h-100`}>
        <div className={classes.scrollInner}>
          <p className='mc-text-small mc-opacity--hinted'>{description}</p>
          <InfoItem
            i18nKey='series.about.instructors'
            values={{ instructorName: starring }}
            className='mc-mt-6 mc-mb-2'
          />
          <InfoItem
            i18nKey='series.about.length'
            values={{ chapters: length }}
            className='mc-mb-2'
          />
          <InfoItem i18nKey='series.about.category' values={{ categories }} />
        </div>
      </div>
    </div>
  </>
)
